<script lang="ts" setup>
import { IYearMonth } from '@/coreDomainsModule/date';
import DatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { computed } from 'vue';
import { i18n } from '@/i18n';

const t = i18n.t;

// props
const props = withDefaults(
  defineProps<{
    modelValue?: IYearMonth; // 渡す際は、Date型のmonthの規定に合わせて渡してください
    locale?: string;
    placeholder?: string;
    propFormat?: string; // TODO: i18n対応で、リージョンごとに表示を変えられるようにする
    useTeleport?: boolean; // teleportを使って配置されるかどうか。offの場合はbodyに配置される
    minDate?: IYearMonth; // 選択可能な最小年月
    maxDate?: IYearMonth; // 選択可能な最大年月
  }>(),
  {
    // eslint-disable-next-line jsdoc/require-jsdoc
    modelValue: undefined,
    locale: 'ja',
    placeholder: '年月を選択してください',
    propFormat: 'yyyy年M月',
    useTeleport: true,
    minDate: undefined,
    maxDate: undefined,
  }
);

/**
 * 最小日付をDate型に変換
 */
const minDateValue = computed(() => {
  if (!props.minDate) return undefined;
  // IYearMonthの月は1-indexed、DateコンストラクタのmonthIndexは0-indexed
  // その月の初日を設定
  return new Date(props.minDate.year, props.minDate.month - 1, 1);
});

/**
 * 最大日付をDate型に変換
 */
const maxDateValue = computed(() => {
  if (!props.maxDate) return undefined;
  // IYearMonthの月は1-indexed、DateコンストラクタのmonthIndexは0-indexed
  // その月の最終日を設定するため、翌月の0日目を指定
  return new Date(props.maxDate.year, props.maxDate.month, 0);
});

/**
 * 年月情報
 */
const yearMonthInfo = computed({
  // eslint-disable-next-line jsdoc/require-jsdoc
  get: () => {
    let getValue = props.modelValue;
    if (!getValue) return undefined;
    getValue = {
      year: getValue.year,
      month: getValue.month - 1,
    };
    return getValue;
  },
  // eslint-disable-next-line jsdoc/require-jsdoc
  set: (val) => {
    if (!val) return;
    // そのままだと、Date型の月情報と同じなので+1して返す
    val = {
      year: val.year,
      month: val.month + 1,
    };
    return emits('update:model-value', val);
  },
});

// emits
const emits = defineEmits<{
  (e: 'update:model-value', modelValue: IYearMonth): IYearMonth;
  (e: 'open'): void;
  (e: 'closed'): void;
}>();
</script>
<template>
  <DatePicker
    v-model="yearMonthInfo"
    :teleport="useTeleport"
    :clearable="false"
    :format="propFormat"
    :locale="props.locale"
    :placeholder="t(props.placeholder)"
    :min-date="minDateValue"
    :max-date="maxDateValue"
    month-picker
    auto-apply
    @open="emits('open')"
    @closed="emits('closed')"
  />
</template>
